import type { SupportedLocale } from "staticConfiguration";
import type { CentrixSchemas } from "core/entities/APITypes";

export const MAXIMUM_QUICK_LINKS = 10;

export type QuickLinkWidgetSettingsDto =
  CentrixSchemas["Fixhub.QuickLinks.QuickLinkWidgetSettingsDto"];
export type QuickLinkWidgetSettingsCreateUpdateDto =
  CentrixSchemas["Fixhub.QuickLinks.QuickLinkWidgetSettingsCreateUpdateDto"];
export type QuickLinkCreateUpdateDto =
  CentrixSchemas["Fixhub.QuickLinks.QuickLinkUpdateDto"];
export type QuickLinkType = CentrixSchemas["Fixhub.QuickLinks.QuickLinkType"];

export type QuickLinkWidgetFormValues = {
  isEnabled: boolean;
  currentTab: QuickLinkType;
  selectedQuickLinks: SelectedQuickLink[];
  quickLinkOrder: string[];
};

export type SelectedQuickLink = {
  id: string;
  type: QuickLinkType;
  customLink?: CustomLinkFormData;
};

export type CustomLinkFormData = {
  currentLocaleTab: SupportedLocale;
  translations: CustomLinkTranslation[];
};

type CustomLinkTranslation = {
  locale: string;
  name: string;
  url: string;
};
